import { render, staticRenderFns } from "./eRemitPayDetail.vue?vue&type=template&id=88354532&scoped=true&"
import script from "./eRemitPayDetail.vue?vue&type=script&lang=js&"
export * from "./eRemitPayDetail.vue?vue&type=script&lang=js&"
import style0 from "./eRemitPayDetail.vue?vue&type=style&index=0&id=88354532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88354532",
  null
  
)

export default component.exports